import { render, staticRenderFns } from "./ShiftReportUnified.vue?vue&type=template&id=168abb1f&scoped=true&"
import script from "./ShiftReportUnified.vue?vue&type=script&lang=js&"
export * from "./ShiftReportUnified.vue?vue&type=script&lang=js&"
import style0 from "./ShiftReportUnified.vue?vue&type=style&index=0&id=168abb1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168abb1f",
  null
  
)

export default component.exports